import React from 'react';
import { ScrollAnimationsContext } from './ScrollAnimationsProvider';

/**
 * Assigns container and trigger elements to the 'simple', 'clean', and 'satisfying' scenes.
 * The elements hold no content but serve as a way to track progress through each phase of the scrolling animations.
 */

export const SimpleCleanSatisfyingScenes = () => {
  const simpleTriggerElement = React.useRef(null);
  const simpleGapTrigger = React.useRef(null);
  const cleanTrigger = React.useRef(null);
  const cleanGapTrigger = React.useRef(null);
  const satisfyingTrigger = React.useRef(null);
  const satisfyingGapTrigger = React.useRef(null);

  const {
    simpleScene,
    simpleGapScene,
    cleanScene,
    cleanGapScene,
    satisfyingScene,
    satisfyingGapScene,
  } = React.useContext(ScrollAnimationsContext);

  React.useEffect(() => {
    simpleScene
      .triggerElement(simpleTriggerElement.current)
      // {pushFollowers: false} prevents the elements after the pinned element from being shifted down
      // and creating a gap. This allows us to have scenes back-to-back with constant progress tracking.
      .setPin('#with-smokers', { pushFollowers: false });
    simpleGapScene
      .triggerElement(simpleGapTrigger.current)
      .setPin('#with-smokers', { pushFollowers: false });
    cleanScene
      .triggerElement(cleanTrigger.current)
      .setPin('#with-smokers', { pushFollowers: false });
    cleanGapScene
      .triggerElement(cleanGapTrigger.current)
      .setPin('#with-smokers', { pushFollowers: false });
    satisfyingScene
      .triggerElement(satisfyingTrigger.current)
      .setPin('#with-smokers', { pushFollowers: false });

    return;
  }, [
    cleanGapScene,
    cleanScene,
    satisfyingGapScene,
    satisfyingScene,
    simpleGapScene,
    simpleScene,
  ]);

  return (
    <>
      <div id="simpleTrigger" ref={simpleTriggerElement} />
      <div
        className="starterKit-scene-container"
        style={{ height: simpleScene.duration() }}
      />

      <div id="simpleGapTrigger" ref={simpleGapTrigger} />
      <div id="simpleGapScene" style={{ height: simpleGapScene.duration() }} />

      <div id="cleanTrigger" ref={cleanTrigger} />
      <div
        className="starterKit-scene-container"
        style={{ height: cleanScene.duration() }}
      />

      <div id="cleanGapTrigger" ref={cleanGapTrigger} />
      <div id="simpleGapScene" style={{ height: cleanGapScene.duration() }} />

      <div id="satisfyingTrigger" ref={satisfyingTrigger} />
      <div
        className="starterKit-scene-container"
        style={{ height: satisfyingScene.duration() }}
      />

      <div id="satisfyingGapTrigger" ref={satisfyingGapTrigger} />
    </>
  );
};
